import { createSelector } from 'reselect';
import { workSizeDetails } from './work_sizes';

const pricingSelector = ({ canvas: { pricing } }) => pricing;

const groupPrice = (works) => works.reduce(
  (a, w) => a + parseFloat((w.nonGlare ? w.nonGlarePrice : w.price) || 0), 0
);

export const panelGroups = createSelector(
  workSizeDetails,
  pricingSelector,
  (works, pricing) => {
    const byId = {};
    works.forEach((w) => { byId[w.wallPictureId] = w; });

    if (!pricing) {
      return [{
        sourceWallId: null, name: null, badge: null, complete: false, showHeader: false, works
      }];
    }

    const groups = pricing.groups.map((g) => ({
      sourceWallId: g.sourceWallId,
      times: g.times,
      itemsPrice: g.itemsPrice,
      discount: g.discount,
      // `complete` comes from the server (complete means EARNED, and it is already false
      // for partners). Never re-derive it from discount/times here, or the badge drifts
      // out of step with the total.
      complete: g.complete,
      // A group that is not earning its discount stops being a gallery in this panel: no
      // wall name and no badge, so it reads as the loose pieces it now is. `reason` /
      // `changedCount` are still in the payload; nothing renders them any more.
      name: g.complete ? g.name : null,
      badge: g.complete ? `−${ g.discountPercent }%` : null,
      showHeader: true,
      works: g.wallPictureIds.map((id) => byId[id]).filter(Boolean)
    }));

    const loose = pricing.looseWallPictureIds.map((id) => byId[id]).filter(Boolean);
    const unassigned = works.filter((w) => !w.wallPictureId);
    const other = [...loose, ...unassigned];
    if (other.length) {
      groups.push({
        sourceWallId: null,
        name: null,
        times: 0,
        // The payload carries no price for loose pictures, so sum them here — otherwise
        // this header reads $0.00 next to groups showing real money.
        itemsPrice: groupPrice(other),
        discount: 0,
        complete: false,
        badge: null,
        showHeader: true,
        works: other
      });
    }
    return groups;
  }
);
